import React from 'react';
export var ChatBubble = function ChatBubble() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "26",
    height: "25",
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7566 14.5695H13.4088L13.2878 14.8957L12.3806 17.3422L8.91092 14.6732L8.77613 14.5695H8.60607H5.38184C5.10569 14.5695 4.88184 14.3457 4.88184 14.0695V5.99771C4.88184 5.72157 5.10569 5.49771 5.38184 5.49771H14.3545H19.8249C20.101 5.49771 20.3249 5.72157 20.3249 5.99771V14.0695C20.3249 14.3457 20.101 14.5695 19.8249 14.5695H13.7566Z",
    fill: "white",
    stroke: "#143F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9397 16.6279H15.5919L15.4709 16.9541L14.6409 19.1923L11.442 16.7316L11.3072 16.6279H11.1371H8.19824C7.9221 16.6279 7.69824 16.404 7.69824 16.1279V8.73651C7.69824 8.46037 7.9221 8.23651 8.19824 8.23651H16.4972H21.5305C21.8066 8.23651 22.0305 8.46037 22.0305 8.73651V16.1279C22.0305 16.404 21.8066 16.6279 21.5305 16.6279H15.9397Z",
    fill: "white",
    stroke: "#143F3D"
  }));
};